import React, { useRef, useEffect } from "react";
import PriceCard from "../../components/common/PriceCard/PriceCard";
import { useSelector } from "react-redux";
import Heading from "../../components/common/Typography/Heading";
import Verified from "../../../src/assets/img/Guarantee.png";
import Dollar from "../../../src/assets/img/Receive-Cash.png";
import Invoice from "../../../src/assets/img/Paid-Bill.png";
import Customer from "../../../src/assets/img/Connectivity-and-Help.png";
import Paragraph from "../../components/common/Typography/Paragraph";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_STORY_POINTS_GAP_CLASS,
  PUBLIC_STORY_MARKER_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

gsap.registerPlugin(ScrollTrigger);

const points = [
  {
    title: "Verified Trade Only",
    desc: "ABN-verified, licensed, and insured. No gig workers—just real tradies.",
  },
  {
    title: "Keep Every Dollar",
    desc: "One flat fee. No commissions. No middlemen.",
  },
  {
    title: "Quote, Invoice & Get Paid",
    desc: "Set your prices, send invoices, and take payments your way.",
  },
  {
    title: "Customers Contact You",
    desc: "Get found locally and get hired fast—calls, messages, or socials.",
  },
];

const BusinesEmpowerment = () => {
  const getPremiumPackageDetail = useSelector((plan) =>
    plan?.PricingPlanReducer.find((item) => item.name === "PREMIUM")
  );

  const sectionRef = useRef(null);
  const bgPinRef = useRef(null);
  const contentRef = useRef(null);
  const pointsRef = useRef([]);
  const addToPointsRef = (el) => {
    if (el && !pointsRef.current.includes(el)) {
      pointsRef.current.push(el);
    }
  };

  useEffect(() => {
    let pointTriggers = [];
    let pinST = null;
    const pointsEls = pointsRef.current;
    const section = sectionRef.current;
    const bgPin = bgPinRef.current;
    const content = contentRef.current;
    if (!section || !bgPin || !content) return;

    function setupPointTriggers() {
      if (!pinST || typeof pinST.start !== "number" || typeof pinST.end !== "number") return;
      // Remove old triggers
      pointTriggers.forEach(t => t.kill());
      pointTriggers = [];
      gsap.set(pointsEls, { opacity: 0, y: 50 });
      const numPoints = pointsEls.length;
      // Use pinST.start and pinST.end for absolute scroll positions
      const pinStart = pinST.start;
      const pinEnd = pinST.end;
      const pinDuration = pinEnd - pinStart;
      pointsEls.forEach((point, i) => {
        const segStart = pinStart + (i * pinDuration) / numPoints;
        const segEnd = pinStart + ((i + 1) * pinDuration) / numPoints;
        const trigger = gsap.to(point, {
          opacity: 1,
          y: 0,
          ease: "power2.out",
          scrollTrigger: {
            start: segStart,
            end: segEnd,
            scrub: true,
            invalidateOnRefresh: true,
          }
        });
        pointTriggers.push(trigger.scrollTrigger);
      });
    }

    // Pin the background image wrapper from where the image starts
    pinST = ScrollTrigger.create({
      trigger: bgPin,
      start: "top top",
      end: "+=120%", // pin for 1.2x the height of the image (shorter pin for fewer points)
      pin: bgPin,
      anticipatePin: 1,
      scrub: false,
    });

    // Initial setup
    setupPointTriggers();
    ScrollTrigger.addEventListener("refresh", setupPointTriggers);
    ScrollTrigger.refresh();

    // Cleanup
    return () => {
      pinST.kill();
      pointTriggers.forEach(t => t.kill());
      ScrollTrigger.removeEventListener("refresh", setupPointTriggers);
    };
  }, []);

  return (
    <div ref={sectionRef} className={`relative w-full h-[231.4vh] overflow-hidden ${PUBLIC_SECTION_GAP_CLASS}`}>
      <div className="bg-pastalblue">
        <div className="tp-container-home mx-auto">
            <Heading variant={"h2"} className={"text-offblack"}>
                Empower your business
            </Heading>
        </div>
      </div>
      {/* Pin this background image wrapper */}
      <div ref={bgPinRef} className={`w-full h-screen relative ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
        <div className="bg-mainBanner bg-center bg-cover w-full h-full absolute inset-0"></div>
        <div className="absolute inset-0">
          <div ref={contentRef} className="relative tp-container mx-auto h-full">
            <div className="tp-container-small flex justify-center sm:justify-start h-full items-center my-auto mx-auto xl:px-8 pb-[6%]">
              <div className={`flex flex-col text-white w-[420px] ${PUBLIC_STORY_POINTS_GAP_CLASS} ml-8`}>
                  {points.map((point, i) => (
                    <div ref={addToPointsRef} key={i} className={`flex flex-row items-start ${PUBLIC_STORY_MARKER_GAP_CLASS}`}>
                      <div className="flex-none" style={{ height: '20px', width: '5px', background: 'white', borderRadius: 0, marginTop: '6px', flexShrink: 0, display: 'block' }}></div>
                      <Heading variant={"h5"} className={"font-bold !text-white"}>{point.title}. {point.desc}</Heading>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinesEmpowerment;
